import React from 'react';
import {Route, Routes} from "react-router-dom"
import {Main} from "./pages/Main";
import {Terms} from "./pages/Terms";

export const App = () => {
    return (
        <div>
            <Routes>
                <Route path='/' element={<Main/>}></Route>
                <Route path='/Terms' element={<Terms/>}></Route>
            </Routes>
        </div>
    );
};